import { createContext } from 'react';
import { ToggleButtonGroupOption } from '../ToggleButtonGroup/ToggleButtonGroup';

export type OrigamiElement =
  | 'RadioGroup'
  | 'Radio'
  | 'Input'
  | 'Button'
  | 'ToggleButtonGroup'
  | 'Hint'
  | 'Card';

export interface OrigamiUIEvent {
  eventId: string;
  element: OrigamiElement;
}

export interface RadioGroupEvent extends OrigamiUIEvent {
  element: 'RadioGroup';
  value: string;
}

export interface ToggleButtonGroupEvent extends OrigamiUIEvent {
  element: 'ToggleButtonGroup';
  selected: ToggleButtonGroupOption;
}

export interface RadioEvent extends OrigamiUIEvent {
  element: 'Radio';
  value: string;
  checked: boolean;
}

export interface ButtonEvent extends OrigamiUIEvent {
  element: 'Button';
}

export interface CardEvent extends OrigamiUIEvent {
  element: 'Card';
}

export interface HintEvent extends OrigamiUIEvent {
  element: 'Hint';
  open: boolean;
}

export interface InputEvent extends OrigamiUIEvent {
  element: 'Input';
  value: string;
}

export type OnClickEvent<
  T extends OrigamiUIEvent,
  E extends EventTarget
> = T & {
  target: E;
};

export type OnChangeEvent<T extends OrigamiUIEvent> = T;

export type OnClickHandler<
  T extends OrigamiUIEvent,
  E extends EventTarget
> = EventHandler<OnClickEvent<T, E>>;

export type OnChangeHandler<T extends OrigamiUIEvent> = EventHandler<
  OnChangeEvent<T>
>;

export type EventHandler<E extends OrigamiUIEvent> = {
  bivarianceHack(event: E): void;
}['bivarianceHack'];

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const EventContext = createContext<EventHandler<OrigamiUIEvent>>(noop);

const EventProvider = EventContext.Provider;

export default EventProvider;
